/**
 * Renuvella · ficha de producto
 *
 * Tres cosas, ninguna con estado propio:
 *
 *   1. Eco de la variante. El estado real vive en el <form>: las tarjetas de
 *      plan son radios con name="id". Esto solo copia el nombre y el precio a
 *      la barra fija y sincroniza ?variant= en la URL.
 *   2. Barra de compra fija. Aparece cuando el boton principal quedo arriba
 *      del viewport. Es fixed con transform, aparecer no mueve contenido.
 *   3. Galeria. Los puntos y las miniaturas mueven el carrusel de scroll-snap,
 *      y el zoom abre un <dialog> nativo.
 *
 * Sin librerias, sin localStorage, sin sessionStorage.
 */
(function () {
  'use strict';

  var MENOS_MOVIMIENTO =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------
     1. Eco de la variante elegida
     --------------------------------------------------------------------- */

  // El primer grupo de packs, el del hero, es el que da el estado inicial.
  var planes = document.querySelector('[data-rnv-planes]');
  var stickyNombre = document.querySelector('[data-rnv-sticky-nombre]');
  var stickyPrecio = document.querySelector('[data-rnv-sticky-precio]');
  var urgencia = document.querySelector('[data-rnv-urgencia]');
  var urgenciaTexto = document.querySelector('[data-rnv-urgencia-texto]');

  function eco() {
    // En todo el documento, no solo en el primer grupo: los packs de la caja
    // de abajo son del mismo grupo de radios y pueden ser los marcados.
    var marcado = document.querySelector('.rnv-plan-card__radio:checked');
    if (!marcado) return;

    if (stickyNombre) stickyNombre.textContent = marcado.getAttribute('data-nombre') || '';
    if (stickyPrecio) stickyPrecio.textContent = marcado.getAttribute('data-precio') || '';

    // El stock viaja en el radio, puesto por Liquid desde Shopify. Aca solo se
    // copia: no se calcula, no se estima y no se inventa. Si el pack elegido no
    // trae numero, o esta sobre el umbral, la franja desaparece en vez de
    // quedarse mostrando el dato del pack anterior.
    if (urgencia && urgenciaTexto && urgencia.hasAttribute('data-rnv-urgencia-stock')) {
      var quedan = parseInt(marcado.getAttribute('data-stock'), 10);
      var umbral = parseInt(urgencia.getAttribute('data-rnv-urgencia-stock'), 10);
      if (quedan > 0 && quedan <= umbral) {
        urgenciaTexto.textContent =
          quedan === 1 ? 'Queda 1 unidad de este pack' : 'Quedan ' + quedan + ' unidades de este pack';
        urgencia.hidden = false;
      } else {
        urgencia.hidden = true;
      }
    }

    // ?variant= es la convencion de Shopify para compartir y volver.
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', marcado.value);
      window.history.replaceState({}, '', url);
    } catch (e) {
      /* Si el navegador no deja reescribir la URL, no pasa nada mas. */
    }
  }

  if (planes) {
    // Se escucha en document: los dos grupos de packs viven en secciones
    // distintas y el evento change burbujea hasta aca desde cualquiera.
    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.classList.contains('rnv-plan-card__radio')) eco();
    });
    eco();
  }

  /* ---------------------------------------------------------------------
     2. Barra de compra fija
     --------------------------------------------------------------------- */

  var sticky = document.querySelector('[data-rnv-sticky]');
  var comprar = document.querySelector('[data-rnv-comprar]');

  if (sticky && comprar) {
    // Nace con hidden para que sin JS nunca aparezca una barra que no sirve.
    sticky.hidden = false;

    // Con IntersectionObserver esto se rompia en un caso real: un salto de
    // scroll instantaneo (un ancla, o recargar con la posicion restaurada)
    // lleva el boton de "abajo del viewport" a "arriba del viewport" sin
    // cruzar ningun umbral, asi que el observer nunca dispara y la barra no
    // aparece. Un listener de scroll con rAF si es correcto siempre, y cuesta
    // un getBoundingClientRect por frame solo mientras se scrollea.
    var pendiente = false;

    function evaluar() {
      pendiente = false;
      // Aparece cuando el boton principal ya quedo arriba del todo, y se
      // esconde mientras la caja de compra de abajo esta a la vista: dos
      // botones de compra a la vez sobran.
      var pasoElBoton = comprar.getBoundingClientRect().bottom < 0;
      var cajaAbajo = document.querySelector('.rnv-compra');
      var cajaVisible = false;
      if (cajaAbajo) {
        var r = cajaAbajo.getBoundingClientRect();
        cajaVisible = r.top < window.innerHeight && r.bottom > 0;
      }
      sticky.classList.toggle('is-on', pasoElBoton && !cajaVisible);
    }

    function alMover() {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(evaluar);
    }

    window.addEventListener('scroll', alMover, { passive: true });
    window.addEventListener('resize', alMover, { passive: true });
    evaluar();

    // Dawn marca aria-disabled en su boton mientras agrega al carro.
    // Lo reflejamos para que no se pueda enviar dos veces desde la barra.
    var stickyBtn = sticky.querySelector('button[type="submit"]');
    if (stickyBtn && 'MutationObserver' in window) {
      new MutationObserver(function () {
        stickyBtn.disabled = comprar.getAttribute('aria-disabled') === 'true';
      }).observe(comprar, { attributes: true, attributeFilter: ['aria-disabled'] });
    }
  }

  /* ---------------------------------------------------------------------
     3. Galeria
     --------------------------------------------------------------------- */

  var galeria = document.querySelector('[data-rnv-galeria]');
  if (!galeria) return;

  var pista = galeria.querySelector('[data-rnv-pista]');
  var slides = pista ? pista.querySelectorAll('.rnv-gal__slide') : [];
  var botones = galeria.querySelectorAll('[data-rnv-ir]');

  Array.prototype.forEach.call(botones, function (boton) {
    boton.addEventListener('click', function () {
      var i = parseInt(boton.getAttribute('data-rnv-ir'), 10);
      if (!slides[i]) return;
      slides[i].scrollIntoView({
        block: 'nearest',
        inline: 'center',
        behavior: MENOS_MOVIMIENTO ? 'auto' : 'smooth',
      });
    });
  });

  if (slides.length > 1 && 'IntersectionObserver' in window) {
    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = e.target.getAttribute('data-indice');
          Array.prototype.forEach.call(botones, function (boton) {
            var activo = boton.getAttribute('data-rnv-ir') === i;
            boton.classList.toggle('is-on', activo);
            if (boton.hasAttribute('aria-selected')) {
              boton.setAttribute('aria-selected', activo ? 'true' : 'false');
            }
          });
        });
      },
      { root: pista, threshold: 0.6 }
    );

    Array.prototype.forEach.call(slides, function (slide) {
      observador.observe(slide);
    });
  }

  /* Zoom: <dialog> nativo, o sea Esc y foco atrapado sin escribir nada */
  var dialogo = document.querySelector('[data-rnv-dialogo]');
  if (!dialogo || typeof dialogo.showModal !== 'function') return;

  var imagen = dialogo.querySelector('[data-rnv-zoom-img]');

  galeria.addEventListener('click', function (ev) {
    var boton = ev.target.closest('[data-rnv-zoom]');
    if (!boton || !imagen) return;
    // El alto y el ancho se actualizan antes que el src para que el dialogo
    // reserve el espacio y no salte cuando la imagen llega.
    var ancho = boton.getAttribute('data-rnv-zoom-w');
    var alto = boton.getAttribute('data-rnv-zoom-h');
    if (ancho) imagen.setAttribute('width', ancho);
    if (alto) imagen.setAttribute('height', alto);
    imagen.src = boton.getAttribute('data-rnv-zoom');
    imagen.alt = boton.getAttribute('data-rnv-zoom-alt') || '';
    dialogo.showModal();
  });

  dialogo.addEventListener('click', function (ev) {
    if (ev.target === dialogo) dialogo.close();
  });

  var cerrar = dialogo.querySelector('[data-rnv-cerrar]');
  if (cerrar) {
    cerrar.addEventListener('click', function () {
      dialogo.close();
    });
  }
})();

/* ---------------------------------------------------------------------------
   Segunda caja de compra.

   No hay codigo. Y esa es la solucion, no una omision.

   Los radios de la caja de abajo cuelgan del formulario del hero por el
   atributo form= de HTML. Como comparten formulario y nombre, el navegador los
   trata como un solo grupo de radios: elegir abajo desmarca arriba, el envio
   lleva lo ultimo que se toco, y el teclado navega entre los seis packs como
   un grupo. Nada de eso necesita JavaScript.

   Lo unico que si hace falta es que el eco del precio escuche tambien los
   cambios de la caja de abajo, y eso esta resuelto arriba escuchando en
   document en vez de en un contenedor.
--------------------------------------------------------------------------- */

/* ---------------------------------------------------------------------------
   Suscripcion.

   El checkbox no viaja al carro: lo que viaja es el campo selling_plan. Se
   llena con el id del plan de venta al marcar y se vacia al desmarcar, porque
   /cart/add rechaza un selling_plan vacio si viene con valor invalido.
--------------------------------------------------------------------------- */
(function () {
  var check = document.querySelector('[data-rnv-susc]');
  var campo = document.querySelector('[data-rnv-susc-valor]');
  if (!check || !campo) return;

  function sincronizar() {
    campo.value = check.checked ? check.value : '';
    campo.disabled = !check.checked;
  }

  check.addEventListener('change', sincronizar);
  sincronizar();
})();
